import axios from "axios";

const BASE_URL = `${process.env.REACT_APP_BASE_URL}`;

export const getUserWiseProfile = async (userId, token) => {
  try {
    const response = await axios.get(
      `${BASE_URL}api/signup/get-userwise-userid?userId=${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data.Result;
  } catch (error) {
    throw new Error("Failed to fetch user details");
  }
};

export const getUserWiseProject = async (userId, token, page, size) => {
  try {
    const response = await axios.get(
      `${BASE_URL}api/getByProjectListByUserId?userId=${userId}&page=${page}&size=${size}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data.Result;
  } catch (error) {
    throw new Error("Failed to fetch projects");
  }
};

export const uploadProject = async (
  projectData,
  userId,
  token,
  countryId,
  area,
  year,
  name
) => {
  try {
    const response = await axios.post(
      `${BASE_URL}api/insert-projects`,
      {
        ...projectData,
        User: { UserId: userId, UserName: name },
        Country: { countryId: countryId },
        Area: area,
        Years: year,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || "Something went wrong");
  }
};

export const getUserWiseProduct = async (userId, token, page, size) => {
  try {
    const response = await axios.get(
      `${BASE_URL}api/products/getByProductListByUserId?userId=${userId}&page=${page}&size=${size}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data.Result;
  } catch (error) {
    throw new Error("Failed to fetch products");
  }
};

export const uploadProduct = async (productData, userId, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}api/products/insert-products`,
      {
        ...productData,
        user: { UserId: userId },
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || "Something went wrong");
  }
};

export const getAllCollaborators = async (userId, token, page, size) => {
  try {
    const response = await axios.get(
      `${BASE_URL}api/signup/get-collaborators-by-userid?userId=${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data.Result;
  } catch (error) {
    throw new Error("Failed to fetch projects");
  }
};

export const funCollabStatus = async (collabStatus) => {
  try {
    const response = await fetch(`${BASE_URL}api/responseCollaboration`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(collabStatus),
    });
    if (!response.ok) {
      throw new Error("Failed to fetch project details");
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error("Error fetching project details: " + error.message);
  }
};

// Admin api call

export const getAllCombUsers = async (page, size) => {
  try {
    const response = await axios.get(
      `${BASE_URL}api/signup/get-all-professional-product-users?page=${page}&size=${size}`
    );

    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch projects");
  }
};

export const getAllProjectList = async (page, size) => {
  try {
    const response = await axios.get(
      `${BASE_URL}api/get-dashboard-projects?page=${page}&size=${size}`
    );

    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch projects");
  }
};

export const getAllProducts = async (page, size) => {
  try {
    const response = await axios.get(
      `${BASE_URL}api/products/getAllProducts?page=${page}&size=${size}`
    );

    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch projects");
  }
};

export const submissionProjects = async () => {
  try {
    const response = await axios.get(`${BASE_URL}api/get-submission-projects`);
    return response.data.Result;
  } catch (error) {
    throw new Error("Failed to fetch projects");
  }
};

export const funProjectStatus = async (projectStatus) => {
  try {
    const response = await fetch(`${BASE_URL}api/project-approval-status`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(projectStatus),
    });
    if (!response.ok) {
      throw new Error("Failed to fetch project details");
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error("Error fetching project details: " + error.message);
  }
};

export const getAllScamReports = async (token, page, size) => {
  try {
    const response = await axios.get(
      `${BASE_URL}api/get-all-scam-reports?page=${page}&size=${size}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch projects");
  }
};

export const funScamStatus = async (scamStatus) => {
  try {
    const response = await fetch(`${BASE_URL}api/report-status`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(scamStatus),
    });
    if (!response.ok) {
      throw new Error("Failed to fetch project details");
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error("Error fetching project details: " + error.message);
  }
};

export const fetchTagsTypologyData = async () => {
  try {
    const response = await axios.get(`${BASE_URL}api/get-typology-count`);
    if (response.data && response.data.Result) {
      return response.data.Result;
    }
    return [];
  } catch (error) {
    console.error("Error fetching typology data:", error);
    throw error;
  }
};

export const fetchTagsCountryData = async () => {
  try {
    const response = await axios.get(`${BASE_URL}api/countriesCount`);
    if (response.data && response.data.Result) {
      return response.data.Result;
    }
    return [];
  } catch (error) {
    console.error("Error fetching country data:", error);
    throw error;
  }
};

export const getAllMagzinesByMonth = async (token, month) => {
  try {
    const response = await axios.get(`${BASE_URL}api/view-magazine`, {
      params: {
        page: 0,
        size: 10,
        month: month,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch projects");
  }
};

export const getAllMagzines = async (token) => {
  try {
    const response = await axios.get(`${BASE_URL}api/view-magazine`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch projects");
  }
};

export const uploadMagazine = async (magzineData, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}api/upload`,
      {
        ...magzineData,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || "Something went wrong");
  }
};

export const deleteProject = async (projectId) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    await axios.post(
      `${BASE_URL}api/deleteProject`,
      { ProjectId: projectId },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );
    return true;
  } catch (error) {
    console.error("Error deleting project:", error);
    throw error;
  }
};

export const deletePrduct = async (productId) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    await axios.post(
      `${BASE_URL}api/products/delete-by-product-id`,
      { ProductId: productId },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );
    return true;
  } catch (error) {
    console.error("Error deleting project:", error);
    throw error;
  }
};

export const deleteUser = async (userId) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    await axios.post(
      `${BASE_URL}api/signup/delete-by-userid`,
      { UserId: userId },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );
    return true;
  } catch (error) {
    console.error("Error deleting project:", error);
    throw error;
  }
};

export const deleteMagazine = async (magazineId) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    await axios.post(
      `${BASE_URL}api/delete-by-magazine-id`,
      { MagazineId: magazineId },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );
    return true;
  } catch (error) {
    console.error("Error deleting project:", error);
    throw error;
  }
};

export const updateProduct = async (productData, userId, token, productId) => {
  try {
    const response = await axios.post(
      `${BASE_URL}api/products/update-products`,
      { ProductId: productId, ...productData }, 
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const updateProject = async (projectData, userId, token, projectId) => {
  try {
    const response = await axios.post(
      `${BASE_URL}api/update-projects`,
      { ProjectId: projectId, ...projectData }, 
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
